import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

function i18n({
  locale,
  localeResource
}) {
  if (i18next.isInitialized) {
    return i18next.cloneInstance({
      lng: locale,
      resources: {
        [locale]: { translation: localeResource }
      }
    });
  }
  i18next.use(initReactI18next).init({
    lng: locale,
    keySeparator: "$",
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: true
    },
    resources: {
      [locale]: { translation: localeResource }
    }
  });
  return i18next;
}

export { i18n as default };
//# sourceMappingURL=i18n.js.map
